import React from "react";

interface CheckCircleIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({
  className = "",
  width = 24,
  height = 24,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill="#EBF1EC"
      />
      <path
        d="M9.86337 14.5836L7.55004 12.2703C7.29004 12.0103 6.87004 12.0103 6.61004 12.2703C6.35004 12.5303 6.35004 12.9503 6.61004 13.2103L9.39671 15.9969C9.65671 16.2569 10.0767 16.2569 10.3367 15.9969L17.39 8.94359C17.65 8.68359 17.65 8.26359 17.39 8.00359C17.13 7.74359 16.71 7.74359 16.45 8.00359L9.86337 14.5836Z"
        fill="#0B6538"
      />
    </svg>
  );
};

export default CheckCircleIcon;
